module.exports = __webpack_public_path__ + "static/img/articlefoot_img_bg_gzh.39db2db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articlefoot_img_bg_gzh.png
// module id = mE+q
// module chunks = 0